import { render } from "./CopySerialSuccessModal.vue?vue&type=template&id=f5924b9a&scoped=true"
import script from "./CopySerialSuccessModal.vue?vue&type=script&lang=js"
export * from "./CopySerialSuccessModal.vue?vue&type=script&lang=js"

import "./CopySerialSuccessModal.vue?vue&type=style&index=0&id=f5924b9a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5924b9a"]])

export default __exports__